import React from 'react';
import { PATH } from '~/pages/deals/[id]/deal_estimation_headers/[headerId]/index';
import { useDealEstimations } from '~/hooks/deals/useDealEstimations';
import { useDealBillings } from '~/hooks/deals/useDealBillings';
import { BillingCreateNavigation } from '~/components/common/constructions/navigation/BillingCreateNavigation';
import { Deal } from '~/models/Deal';
import { isOwnStatus, SEND_ESTIMATE } from '~/models/Status';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { EstimationHistoryNavigation } from '~/components/common/constructions/navigation/EstimationHistoryNavigation';
import { useDealEstimationHeaders } from '~/hooks/deals/useDealEstimationHeaders';
import { ConstructionClientNavigation } from '~/components/common/constructions/navigation/ConstructionClientNavigation';

type Props = {
  deal: Deal;
};

export const EstimationClientPanel: React.FC<Props> = ({ deal }: Props) => {
  const id = useIdQueryHandler();
  const { data: estimationContext } = useDealEstimations().index(id);
  const { data: dealEstimationHeaders } = useDealEstimationHeaders().index(id);
  const { data: ownerBillingContext, mutate: mutateOwnerBillings } =
    useDealBillings().index(id, 'owner');
  const { data: renteeBillingContext, mutate: mutateRenteeBillings } =
    useDealBillings().index(id, 'rentee');
  const mutateBillings = React.useCallback(async () => {
    mutateOwnerBillings && (await mutateOwnerBillings());
    mutateRenteeBillings && (await mutateRenteeBillings());
  }, [mutateOwnerBillings, mutateRenteeBillings]);
  if (
    id === null ||
    estimationContext === null ||
    ownerBillingContext === null ||
    renteeBillingContext === null ||
    dealEstimationHeaders === null
  ) {
    return null;
  }
  return (
    <div>
      {deal.status >= SEND_ESTIMATE && (
        <>
          <ConstructionClientNavigation title="工事見積書" />
          <BillingCreateNavigation
            deal={deal}
            estimationContext={estimationContext}
            mutateBillings={mutateBillings}
            ownerBillingContext={ownerBillingContext}
            renteeBillingContext={renteeBillingContext}
            title="工事請求書"
          />
          <EstimationHistoryNavigation
            dealEstimationHeaders={dealEstimationHeaders}
            detailPagePath={(headerId: number): string => PATH(id, headerId)}
            ownManagement={isOwnStatus(deal.status)}
          />
        </>
      )}
    </div>
  );
};
